module.exports = __webpack_public_path__ + "img/facebook-b.c22a4dca.svg";